import { Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');

  if (token) {
    return children;
  } else {
    toast.error('Bạn chưa đăng nhập');
  }

  return <Navigate to="/" />;
};
